import * as UIs from '@headlessui/vue'

type UIKeys = keyof typeof UIs

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  Object.keys(UIs).forEach((ui: string) => {
    nuxtApp.vueApp.component('Hui' + ui, UIs[ui as UIKeys])
  })
})
